import { TipoButtonConstants } from "../../../types/typesConstants";
import { Card, ButtonUi } from "../../ui";
import { Space, Tooltip } from "antd";
import { useSelector } from "react-redux";
import { ClientePrincipalPart } from "./ClientePrincipalPart";
import { ClienteDireccionPart } from "./ClienteDireccionPart";
import { ClienteContacto } from "./ClienteContacto";

export const ClienteForm = ({ handleCloseForm }) => {
  const { activeCliente } = useSelector((state) => state.cliente);
  return (
    <Card
      title={
        <>
          Cliente
          {activeCliente ? <small> Editar</small> : <small> Nuevo</small>}
        </>
      }
      size="small"
      extra={[
        <Space className="site-button-ghost-wrapper" wrap key="Opts">
          <Tooltip title="Salir" key="1">
            <ButtonUi
              typeUi={TipoButtonConstants.Cancelar}
              onClick={handleCloseForm}
            />
          </Tooltip>
          <Tooltip title="Guardar" key="2">
            <ButtonUi
              htmlType="submit"
              form="FormClientes"
              typeUi={TipoButtonConstants.Guardar}
            />
          </Tooltip>
        </Space>,
      ]}
    >
      <ClientePrincipalPart />
      <ClienteContacto />
      <ClienteDireccionPart />
    </Card>
  );
};
